<button type="button" class="dropzone" [disabled]="disabled" (click)="openPicker()">
  @if (compact) {
    <span class="dropzone__icon-tile" aria-hidden="true">
      <svg width="18" height="18" viewBox="0 0 20 20" focusable="false">
        <path
          d="M10 13V4M5.5 8.5 10 4l4.5 4.5M4 16h12"
          fill="none"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>

    <span class="dropzone__copy">
      <span class="dropzone__line">{{ compactLine }}</span>
      <span class="dropzone__support">{{ supportLine }}</span>
    </span>
  } @else {
    <span class="dropzone__icon-tile dropzone__icon-tile--large" aria-hidden="true">
      <svg width="28" height="28" viewBox="0 0 28 28" focusable="false">
        <path
          d="M14 19V6M7 12l7-6 7 6M5 23h18"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>

    <span class="dropzone__title">{{ title }}</span>
    <span class="dropzone__subtitle">{{ subtitle }}</span>
    <span class="dropzone__cta">{{ ctaLabel }}</span>
    <span class="dropzone__support">{{ supportLine }}</span>
  }
</button>

<input
  #fileInput
  type="file"
  class="dropzone__file-input"
  [accept]="accept"
  multiple
  (change)="onFilesPicked($event)"
/>
